import { Injectable, inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { DialogRef, DialogService, DialogSettings } from '@progress/kendo-angular-dialog';
import { Observable, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root' 
})
export class ExtendedDialogService extends DialogService {
    protected router = inject(Router);

    override open(options: DialogSettings, closeOnRouteChange: boolean = true): DialogRef {
        const dialogRef: DialogRef = super.open(options);

        if (closeOnRouteChange) {
            let navigationStart: Observable<NavigationStart> = this.router.events.pipe(filter(event => event instanceof NavigationStart), map(event => <NavigationStart>event));

            let subscription: Subscription = navigationStart.subscribe(() => {
                dialogRef.close();
            });
    
            //Wenn der Dialog durch den User geschlossen wird oder automatisch durch eine Navigation, dann wird die Subscription aufgeräumt
            dialogRef.dialog.onDestroy(() => {
                if (subscription)
                    subscription.unsubscribe();
            });
        }

        return dialogRef;
    }
}